<template>
  <section id="store-coupon-viewer" class="container">
    <div class="row">
      <div class="col-md-12 mt-2 mb-4">
        <!-- @TODO -  Make this a slot? -->
        <StaticCoupons
          :coupons="coupons"
          @couponClicked="triggerModal"
          v-if="!carouselView && !apiLoading"
        ></StaticCoupons>
        <CouponCarousel
          :coupons="coupons"
          @couponClicked="triggerModal"
          v-if="carouselView && !apiLoading"
        ></CouponCarousel>
        <b-skeleton width="100%" height="300px" v-if="apiLoading"></b-skeleton>
        <StorePromoModal
          ref="promotionModal"
          :promotion="promotion"
          :slide="selectedCoupon"
          @toggleQuote="triggerQuote"
          @toggleAppointment="triggerAppointment"
        ></StorePromoModal>
      </div>
    </div>
  </section>
</template>

<script>
import StorePromoModal from "@/components/partials/StorePromoModal";
const StaticCoupons = () => import("@/components/partials/StaticCoupons.vue");
const CouponCarousel = () => import("@/components/partials/CouponCarousel.vue");
export default {
  name: "StoreCouponViewer",
  //@TODO - We should also check logic for situations where MyStore is set but no promotion is assigned (though we can probably capture that via server and populate default coupons?)
  components: {
    StaticCoupons,
    CouponCarousel,
    StorePromoModal,
  },
  computed: {
    carouselView() {
      if (this.coupons.length == 0) {
        return false;
      }
      if (this.coupons.length >= 4) {
        return true;
      }
      if (this.coupons.length < 4) {
        return false;
      }
      return false;
    },
    selectedCoupon() {
      return this.currentSlide;
    },
  },
  data: () => {
    return {
      currentSlide: 0,
    };
  },
  props: {
    store: Object,
    promotion: Object,
    coupons: Array,
    apiLoading: Boolean,
  },
  methods: {
    triggerModal(index) {
      this.currentSlide = parseInt(index);
      this.$root.$bvModal.show("store-promo-modal");
    },
    triggerQuote() {
      window.tintworldVue.$root.$store.commit("OpenModal", "quote");
      window.tintworldVue.$root.$emit("bv::show::modal", "tint-world-modal");
    },
    triggerAppointment() {
      window.tintworldVue.$root.$store.commit("OpenModal", "appointment");
      window.tintworldVue.$root.$emit("bv::show::modal", "tint-world-modal");
    },
  },
};
</script>
